import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { useParams, useNavigate } from 'react-router-dom';
import propiedades from '../data/propiedades.json';
import Header from './Header';
import MarzipanoTour from './MarzipanoTour';
import PanoramaViewer360 from './PanoramaViewer360';
import Footer from './Footer';

const PropertyTour = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const prop = propiedades.find(p => p.id === parseInt(id) && p.visible !== false);
  if (!prop) {
    navigate('/');
    return null;
  }

  return (
    <>
      <div className="min-h-screen bg-gray-900">
        <Header />
        <motion.div
          className="relative py-8"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <div className="container mx-auto px-4 max-w-6xl">
            <button
              onClick={() => navigate(`/propiedad/${id}`)}
              className="absolute top-4 left-4 z-20 bg-white/90 backdrop-blur-sm p-3 rounded-xl shadow-lg flex items-center gap-2 text-gray-800 font-medium hover:shadow-xl transition-all"
            >
              <ArrowLeft className="w-5 h-5" />
              Volver a Detalles
            </button>

            <div className="relative h-[80vh] rounded-xl overflow-hidden shadow-2xl mb-8">
              {prop.tour360s && prop.tour360s.length > 0 ? (
                <PanoramaViewer360 scenes={prop.tour360s} />
              ) : (
                <>
                  <MarzipanoTour sceneId="0-1" />
                  <div className="absolute inset-0 flex items-center justify-center z-10 rounded-xl pointer-events-none">
                    <p className="text-white text-center px-4 text-lg font-medium">Tour 360° Interactivo — Usa el mouse para explorar</p>
                  </div>
                </>
              )}
            </div>

            <div className="text-center text-white">
              <h2 className="text-2xl font-bold mb-2">{prop.nombre}</h2>
              <p className="text-gray-300">{prop.tipo} - {prop.ubicacion}</p>
            </div>
          </div>
        </motion.div>
      </div>
      <Footer />
    </>
  );
};

export default PropertyTour;
